
import React, { useEffect, useState } from 'react'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
// import MiniHeader from '../../components/global/MiniHeader'
import Footer from '../../components/global/Footer'
import { errorMessage } from '../../constants/errorMessage'
import { useNavigate, useParams } from 'react-router-dom'
import NoData from '../../components/NoData'
import { endParking } from '../../redux/actions/transientAction'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import ConfirmationModal from '../../global/ConfirmationModal'
import UpperHeader from '../../components/global/UpperHeader'
import StartEndDate from '../../components/global/StartEndDate'
import QRCodeComp from '../../components/global/QRCode'
import AmountPaid from '../../components/global/AmountPaid'
import ClockTimer from '../../components/global/ClockTimer'
import ExtendEndButton from '../../components/global/ExtendEndButton'
import PaymentBreakUpDetails from '../../components/global/PaymentBreakUpDetails'
import PromoCode from '../../components/global/PromoCode'
import { getTicketDetails } from '../../redux/actions/ReceiptsAction'
// import { getConfigDetails } from '../../services/config'
import Loader from '../../global/Loader'
import { isPromoValidateButton, priceGreaterOrNot } from '../../utils/helper'
import { getConfigDetails } from '../../../../services/config'

function ExtendResponse(props) {
  const [faciltyData, setFaciltyData] = useState(EMPTY_OBJECT)
  const [isConfimationModalOpen, setIsConfimationModalOpen] = useState(false)
  const [isDisplayDetails, setIsDisplayDetails] = useState(false)
  const [isEndingParking, setIsEndingParking] = useState(false)
  // const [isCouponApplied, setIsCouponApplied] = useState(false)

  const { partner } = useParams()
  const navigate = useNavigate()

  const { dispatch, notify, loader } = props

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {



    const extendDetails = JSON?.parse(localStorage?.getItem('ExtendData'))
    

    const payload = {
      'ticket': extendDetails?.ticket_number,
      'phone': '',
      'cardLast4': '',
      'cardExpiry': '',
      'license_plate': '',
      'partner_id': getConfigDetails()?.PARTNER_ID,
    }
    dispatch(getTicketDetails(payload)).then((res) => {
      if (res?.status === 201 || res?.status === 200) {
        if (res?.data && res?.data != null) {
          // notify('success', 'T successfully')
          // setFaciltyData(res?.data)
          setFaciltyData(res?.data)
          localStorage.setItem('ExtendData', JSON.stringify(res?.data))
          // setRemainingAmount((Number(res?.data?.payable_amount) - Number(res?.data?.grand_total)).toFixed(2))
        } else {
          notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
        }
      } else {
        // setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
        notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
      }
    }).catch(() => {
      notify('error', errorMessage?.somethingWentWrong)
    })


    // setTicketData(Details)

    // const daysHoursLength = convertHoursToDaysMinutes(Number(Details?.length))
    // setHoursToDays(daysHoursLength)
  }, [EMPTY_ARRAY])


  const handleConfimationModal = () => {
    setIsConfimationModalOpen(!isConfimationModalOpen)
  }

  const handleExtend = () => {
    navigate(`/${partner}/extend/${faciltyData?.ticket_number}`)
  }
  const handleEndParking = () => {
    setIsConfimationModalOpen(!isConfimationModalOpen)
    setIsEndingParking(true)

    dispatch(endParking(faciltyData?.ticket_number)).then((res) => {
      if (res?.status === 201 || res?.status === 200) {
        if (res?.data && res?.data != null) {
          localStorage.removeItem('paymentRecipt')
          localStorage.removeItem('ExtendData')
          notify('success', 'Thank you for parking with us. Please visit us again')
          setFaciltyData(res?.data)
          setTimeout(() => {
            const pushBack = JSON.parse(localStorage.getItem('history'))
            navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
            setIsEndingParking(false)

          }, 3000)

        } else {
          notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
        }
      } else {
        notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
      }
    }).catch(() => {
      notify('error', errorMessage?.somethingWentWrong)
    })
  }

  return (
    (loader || isEndingParking) ? <div className='main d-flex align-items-center justify-content-center'><Loader /></div> : <div className={faciltyData ? 'PaveConfirmation' : 'PaveConfirmation main'}>
      {/* <MiniHeader isDisplayBack={true} title={'Current Parking Session'} /> */}
      {partner ? <>
        {/* <h4 className='headerParking my-3 text-info'>Thank You</h4> */}
        <UpperHeader faciltyData={faciltyData} totalHoursLength={faciltyData?.length?.toString()} isDirection screen='extend' />

        <StartEndDate paymentData={faciltyData} />
       {faciltyData?.id ?  <QRCodeComp paymentData={faciltyData} screen='extend' isLicensePlate isMessage/> : null}



        {/* {isCouponApplied == 'false' && <PromoCode  */}
        {(partner !== 'intrapark' && isPromoValidateButton(faciltyData, ['1', '3'])) &&
          <PromoCode
            isTicketApply
            notify={notify}
            setPaymentData={setFaciltyData}
            screen='extend'
            ticketDetails={faciltyData}
          />
        }
        {/* {(priceGreaterOrNot(faciltyData)) && <p className='text-primary my-2 fw-semibold py-1 ps-3 bg-primary bg-opacity-10' >Price Breakup</p>} */}
        <div className="container pt-3 pb-5 overflow-hidden">
          <div className={(!priceGreaterOrNot(faciltyData) && !loader) ? 'card shadow rounded-lg receiptCard no-view' : 'card shadow rounded-lg receiptCard'}>
            <PaymentBreakUpDetails
              paymentData={faciltyData}
              className="my-2 m-2 d-flex justify-content-between"
              sectionKey={((faciltyData?.payable_amount != '0.00') && faciltyData?.payable_amount) ? '' : 'paymantResponse'}
              isDisplayDetails={true}
              setIsDisplayDetails={setIsDisplayDetails}
              isExtendDetails
              breakDownTitle="Price Breakdown"
              screen="extendResponse"

            />
            <div className="card-footer">
              <AmountPaid
                className="row justify-content-between"
                paymentData={faciltyData}
                paybleText='Amount Paid'
                sectionKey={((faciltyData?.payable_amount != '0.00') && faciltyData?.payable_amount) ? '' : 'paymantResponse'}
                // isInfo
                hideTaxIncluded={((faciltyData?.payable_amount > 0 || faciltyData?.amount_paid > 0) && (((faciltyData?.tax_fee && faciltyData?.tax_fee != '0.00') || (faciltyData?.tax_rate && faciltyData?.tax_rate != '0.00')))) ? false : true}
                setIsDisplayDetails={setIsDisplayDetails}
              />
            </div>
          </div>
        </div>

        <ClockTimer
          screen={'extend'}
          facilityData={faciltyData}
        />
        <ExtendEndButton
          handleEndParking={handleConfimationModal}
          handleExtend={handleExtend}
          screen='extend'
          isEndParking
        />

      </> : <NoData message={errorMessage?.invalidPartner} />}
      <PaymentBreakUpDetails
        paymentData={faciltyData}
        className="my-2"
        sectionKey={((faciltyData?.payable_amount != '0.00') && faciltyData?.payable_amount) ? '' : 'paymantResponse'}
        isDisplayDetails={isDisplayDetails}
        setIsDisplayDetails={setIsDisplayDetails}
        isExtendDetails
      />
      <Footer />
      <ConfirmationModal
        isConfimationModalOpen={isConfimationModalOpen}
        setIsConfimationModalOpen={setIsConfimationModalOpen}
        finalAction={handleEndParking}
      />

    </div>
  )
}

ExtendResponse.propTypes = {
  dispatch: PropTypes.func,
  isFetching: PropTypes.bool,
  loader: PropTypes.bool,
  notify: PropTypes.func,

}

ExtendResponse.defaulProps = {
  dispatch: noop,
  loader: false,
  isFetching: false,
  notify: noop,
}

function mapStateToProps({ transientReducer, ReceiptsReducer }) {
  return {
    // loader: transientReducer?.loader,
    loader: ReceiptsReducer?.loader,

    isFetching: transientReducer?.isFetching
  }
}

export default connect(mapStateToProps)(ExtendResponse)